<template>
  <div>
    <div class="current-position">
      <img class="common-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="common-container">
          <div class="current-position-logotext" v-if="pageName=='考生管理'">Examinee</div>
          <div class="current-position-logotext" v-if="pageName=='成绩管理'">Performance</div>
          <div class="current-position-logotext" v-if="pageName=='证书管理'">Certificate</div>
          
        </div>
        <div class="common-container">
          当前位置: 首页  >  培训基地管理  >  考试管理  >  {{pageName}}
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="common-container justify-between">
        <div class="survey-module-right" style="width: 100%;">
          <div class="survey-module-right-title f-w">
            {{pageName}}
          </div>
          <ksglf :examId="examId" v-if="pageName=='考生管理'"/>
          <cjgl :examId="examId" v-if="pageName=='成绩管理'"/>
          <zsgl :examId="examId" v-if="pageName=='证书管理'"/>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import ksglf from '@/components/ksgl/ksglf.vue'
import cjgl from '@/components/ksgl/cjgl.vue'
import zsgl from '@/components/ksgl/zsgl.vue'
export default {
  components:{
    ksglf,
    cjgl,
    zsgl,
  },
  data(){
    return{
      pageName:this.$route.query.name,
      examId:this.$route.query.examId
    }
  },
  created(){},
  methods:{}
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />
<style>
.table-body .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #8fc930 !important;
  border-color: #8fc930 !important;
}
.table-body .el-checkbox__input.is-focus  .el-checkbox__inner{
  border-color: #8fc930 !important;
}
.table-body .el-checkbox__inner:hover{
  border-color: #8fc930 !important;
}
.table-body .el-button--text {
  color: #8fc930 !important;
}
.table-body .el-button--text:hover {
  color: #72b701 !important;
}
</style>
